import axios from 'axios'
import { SIGNIN_ERR, SIGNUP_ERR, UPDATE_PROFILE } from '../constants'

export const SigninAction = (credentials) => {
  return (dispatch) => {
    axios
      .post(`${process.env.REACT_APP_SERVER}auth/login`, credentials, {
        headers: { 'Access-Control-Allow-Origin': '*' },
      })
      .then((res) => {
        const { token, user } = res.data || null
        localStorage.setItem('token', token)
        localStorage.setItem('user', JSON.stringify(user))
        dispatch({
          type: UPDATE_PROFILE,
          payload: user,
        })
        return res.data
      })
      .catch((err) => {
        dispatch({
          type: SIGNIN_ERR,
          payload: err.response.data,
        })
        console.log(err.response)
        return err
      })
  }
}
export const Signup = (data) => async (dispatch) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_SERVER}user/create`,
      data,
    )
    dispatch({
      type: UPDATE_PROFILE,
      payload: res.data,
    })
    localStorage.setItem('token', res?.data?.token)
  } catch (err) {
    dispatch({
      type: SIGNUP_ERR,
      payload: err,
    })
    return err
  }
}
